import React, { createContext, ReactNode, useContext } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { OptionSwitch } from 'src/components'

interface ToastParams {
  message: string | ReactNode
  options?: {
    autoClose?: number | false
  }
}

const ToastContext = createContext<{
  error: (params: ToastParams) => void
  success: (params: ToastParams) => void
  warning: (params: ToastParams) => void
}>({} as any)

const ToastContextProvider = ({ children }: { children: React.ReactNode }) => {
  const error = ({ message, options }: ToastParams) => {
    toast.error(message, {
      autoClose: options?.autoClose
    })
  }

  const success = ({ message, options }: ToastParams) => {
    toast.success(message, {
      autoClose: options?.autoClose
    })
  }

  const warning = ({ message, options }: ToastParams) => {
    toast.warning(message, {
      autoClose: options?.autoClose
    })
  }

  return (
    <ToastContext.Provider
      value={{
        error,
        success,
        warning
      }}
    >
      <ToastContainer />
      {children}
    </ToastContext.Provider>
  )
}
export default ToastContextProvider
export const useToastContext = () => useContext(ToastContext)
